export const auth0ConfigSelector = (state) =>
  state.configuration.auth0Config;

export const stripeConfigSelector = (state) =>
  state.configuration.stripeConfig;

export const contentConfigSelector = state =>
  state.configuration.contentConfig;

export const quizConfigSelector = (state) =>
  state.configuration.quizConfig;

const defaultMaxQuizAttempts = 3;

export const maxQuizAttemptsSelector = (state) =>
  quizConfigSelector(state) ?
    quizConfigSelector(state).maxAttempts :
    defaultMaxQuizAttempts;

const defaultMaxElapseTimeInMillis = 86400000;

export const maxElapseTimeInMillisSelector = (state) =>
  quizConfigSelector(state) ?
    quizConfigSelector(state).maxElapseTimeInMillis :
    defaultMaxElapseTimeInMillis;



// WEBPACK FOOTER //
// ./src/state/modules/configuration/selectors.js